import React from 'react'
import { IGif } from '@giphy/js-types'
import { getGifWidth } from '@giphy/js-util'
import styled from 'styled-components'
import { Gif } from '@giphy/react-components'
import resizeAvatar from 'shared/util/resize-avatar'
import VerifiedBadge from 'shared/components/users/verified-badge'

const MAX_WIDTH = 214
const FIXED_WIDTH = true

const Wrapper = styled.a`
    position: relative;
    height: 223px;
    display: inline-block;
    margin-left: 6px;
    width: auto;
    &:first-of-type {
        margin-left: 0;
    }
`
const Avatar = styled.img`
    width: 60px;
    height: 60px;
`

const AttributionContainer = styled.div`
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translate(-50%, 0%);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
`
const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    width: 200px;
    max-width: ${MAX_WIDTH}px;

    img {
        object-fit: cover;
    }
`

const Username = styled.div`
    color: rgba(255, 255, 255, 0.8);
    display: block;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: bold;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;

    span {
        margin-right: 3px;
    }
`
const DisplayName = styled.div`
    font-size: 18px;
    color: white;
    margin: 6px 0px 1px;
    font-weight: bold;
`

type Props = {
    height: number
    gif: IGif
}

const CalculateWidth = (gif: IGif, height: number) => {
    // Get the GIF's width assuming the gif takes up 70% of the mobile artist preview's height.
    const desiredWidth = getGifWidth(gif, height * 0.7)
    // If Fixed width, then just use 200px and don't calculate width:
    if (FIXED_WIDTH) {
        return 200
    }
    // Don't let 'wide' GIFs take the whole length of the carousel/screen
    return desiredWidth > MAX_WIDTH ? MAX_WIDTH : desiredWidth
}

const MobileArtistPreview = ({ gif, height }: Props) => {
    const user = gif.user
    const { avatar_url } = user
    return (
        <Wrapper href={'/' + user.username}>
            <Container>
                <Gif
                    noLink={true}
                    user={user}
                    key={gif.id}
                    gif={gif}
                    hideAttribution
                    width={CalculateWidth(gif, height)}
                    height={height * 0.7}
                />
                <AttributionContainer>
                    <Avatar src={resizeAvatar(avatar_url, 36)} />
                    <DisplayName>{user.display_name}</DisplayName>
                    <Username>
                        <span>@{user.username}</span>
                        {user.is_verified && <VerifiedBadge is_verified />}
                    </Username>
                </AttributionContainer>
            </Container>
        </Wrapper>
    )
}

export default MobileArtistPreview
